import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Breadcrumbs } from '../Breadcrumb';
import { Grid } from '../Grid';
import Headline3 from '../Typography/Heading/Headline3';
import { JobsLandingContainer as LogosContainer } from '../JobsLanding';
import breakpoints from '../Theme/breakpoints';
import Body1 from '../Typography/Body/Body1';

const StyledHeadline3 = styled(Headline3)`
  && {
    text-align: center;
    margin: 2rem 1rem 1rem;
  }
`;

const CenteredContent = styled(Body1)`
  text-align: center;
`;

const StyledLogosContainer = styled(LogosContainer)`
  margin: 1rem auto;
`;

const LogosTitle = styled(Headline3)`
  margin: 2rem auto;
  text-align: center;
`;

const Container = styled.div`
  padding: 0 1rem;
  max-width: 1100px;
  margin: auto;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0 4rem;
  }
`;

const TextWithImageComponents = styled.div`
  margin-bottom: 4rem;
`;

interface CompanyPageLayoutProperties {
  breadcrumbs: ReactNode[];
  title: string;
  description: string;
  textWithImageComponents?: ReactNode;
  logosTitle?: string;
  logos?: ReactNode;
  advertorials?: ReactNode;
  partnerContentTitle?: string;
  children?: ReactNode;
  uniqueSellingProposition?: ReactNode;
}

const CompanyPageLayout: React.FC<CompanyPageLayoutProperties> = ({
  breadcrumbs,
  title,
  description,
  textWithImageComponents,
  logosTitle,
  logos,
  advertorials,
  partnerContentTitle,
  children,
  uniqueSellingProposition,
}) => (
  <Container>
    <Breadcrumbs crumbs={breadcrumbs} />
    <StyledHeadline3 tag="h1">{title}</StyledHeadline3>
    <CenteredContent>{description}</CenteredContent>
    {uniqueSellingProposition}
    <TextWithImageComponents>{textWithImageComponents}</TextWithImageComponents>
    {children}
    {logosTitle && <LogosTitle>{logosTitle}</LogosTitle>}
    <StyledLogosContainer>{logos}</StyledLogosContainer>
    {partnerContentTitle && (
      <StyledHeadline3 tag="h3">{partnerContentTitle}</StyledHeadline3>
    )}
    <Grid>{advertorials}</Grid>
  </Container>
);

export default CompanyPageLayout;
